import React from 'react';
import voca from 'voca';
import { createMemoryHistory } from 'history';
import queueRoutes from 'queue/routes';
import aboutPageRoutes from 'pages/about/routes';
import cropPageRoutes from 'pages/crop/routes';
import metadataPageRoutes from 'pages/metadata/routes';
import cameraTabRoutes from 'tabs/Camera/routes';
import dropboxTabRoutes from 'tabs/Dropbox/routes';
import facebookTabRoutes from 'tabs/Facebook/routes';
import gdriveTabRoutes from 'tabs/GoogleDrive/routes';
import imageSearchTabRoutes from 'tabs/ImageSearch/routes';
import gettyTabRoutes from 'tabs/Getty/routes';
import iStockTabRoutes from 'tabs/iStock/routes';
import unsplashTabRoutes from 'tabs/Unsplash/routes';
import instagramTabRoutes from 'tabs/Instagram/routes';
import localTabRoutes from 'tabs/Local/routes';
import shutterstockTabRoutes from 'tabs/ShutterStock/routes';
import urlTabRoutes from 'tabs/URL/routes';
import DefaultPanel from '../components/DefaultPanel';
import RouteWithSubRoutes from '../components/RouteWithSubRoutes';

const selfPath = self.location.pathname;
const isHotReloading = module.hot?.status() === 'apply';

const history =
  isHotReloading && self.__cldUwHistory
    ? self.__cldUwHistory
    : createMemoryHistory({
        initialEntries: voca.endsWith(selfPath, '.html') ? ['/'] : [selfPath],
      });

const routes = [
  {
    path: '/',
    exact: true,
    children: (route) => <DefaultPanel route={route} />,
  },
  ...queueRoutes,
  ...aboutPageRoutes,
  ...cameraTabRoutes,
  ...dropboxTabRoutes,
  ...facebookTabRoutes,
  ...gdriveTabRoutes,
  ...imageSearchTabRoutes,
  ...instagramTabRoutes,
  ...localTabRoutes,
  ...shutterstockTabRoutes,
  ...gettyTabRoutes,
  ...iStockTabRoutes,
  ...unsplashTabRoutes,
  ...urlTabRoutes,
  // routes that require to use useExpandedView hook in order to force widget view type
  // to EXPANDED even if "autoMinimize" is true
  ...cropPageRoutes,
  ...metadataPageRoutes,
];

const appRoutes = self.__appRoutes || routes.map((route) => <RouteWithSubRoutes key={`${route.path}`} {...route} />);

self.__appRoutes = appRoutes;

export { appRoutes, history };
